import { NotificationsService } from '../services/NotificationsService'
import { useNotificationsStore } from '../store'
import { NotificationsSupport } from '../support/NotificationsSupport'

import { NotificationsRoutingService } from '#Notifications/routing'

export const useNotifications = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(NotificationsService)
    },
    get store() {
      return useNotificationsStore()
    },
    get support() {
      return alt.get(NotificationsSupport)
    },
    get routing() {
      return alt.get(NotificationsRoutingService)
    },
  }
}
